import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { APP_CONFIG, Settings } from 'src/app/config/settings';
import { combine } from 'src/app/shared/utilities/route';
import { AdditionalRateType } from '../models/additional-rate-type.model';
import { MarginCoverageType } from 'src/app/recruiting/locums-margin-calculator/models/margin-coverage-type.model';

@Injectable({ providedIn: 'root' })
export class AdditionalRatesService {
    private readonly coreApiPath: string;

    constructor(
        private readonly http: HttpClient,
        @Inject(APP_CONFIG) settings: Settings
    ) {
        this.coreApiPath = combine(settings.coreAPIUrl, 'ayanova');
    }

    getAdditionalRateTypes(): Observable<AdditionalRateType[]> {
        const url = combine(this.coreApiPath, `locums/margins/additional-rates/types`);
        return this.http.get<AdditionalRateType[]>(url);
    }

    getMarginCoverageTypes(): Observable<MarginCoverageType[]> {
        const url = combine(this.coreApiPath, `locums/margins/coverage-types`);
        return this.http.get<MarginCoverageType[]>(url);
    }
}
